const focusItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20red%20carpet%20event%20with%20spotlights%20and%20photographers%2C%20celebrity%20entertainment%20news%20vibe%2C%20luxurious%20evening%20atmosphere%20with%20warm%20golden%20lighting%2C%20paparazzi%20flash%20effect%2C%20glamorous%20award%20ceremony%20setting&width=800&height=500&seq=focus-1-51cg-2026&orientation=landscape',
    title: '娱乐圈年度十大爆料事件盘点',
    desc: '回顾今年最劲爆的明星八卦与行业猛料，从恋情曝光到合约纠纷，每一个都是重磅炸弹。',
    tag: '年度盘点',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20studio%20interview%20setting%20with%20single%20spotlight%2C%20mysterious%20atmosphere%2C%20investigative%20journalism%20aesthetic%2C%20warm%20amber%20lighting%20on%20empty%20chair%2C%20cinematic%20mood%2C%20entertainment%20industry%20documentary%20style&width=800&height=500&seq=focus-2-51cg-2026&orientation=landscape',
    title: '深扒直播带货圈那些不为人知的内幕',
    desc: '从选品到售后，从流量到利润，独家解析直播带货产业链背后的真实运作模式。',
    tag: '深度调查',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20feeds%20and%20smartphones%20with%20trending%20content%2C%20digital%20news%20consumption%20concept%2C%20warm%20red%20and%20dark%20color%20scheme%2C%20modern%20internet%20culture%20visual%2C%20viral%20content%20representation&width=800&height=500&seq=focus-3-51cg-2026&orientation=landscape',
    title: '网红塌房实录：从顶流到封杀的72小时',
    desc: '梳理近年来最轰动的网红翻车事件，看流量反噬如何在一瞬之间摧毁多年经营。',
    tag: '热门专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Backstage%20of%20TV%20show%20production%20with%20cameras%20and%20crew%2C%20behind%20the%20scenes%20of%20variety%20show%2C%20warm%20tungsten%20lighting%2C%20professional%20broadcast%20equipment%2C%20entertainment%20industry%20workplace&width=800&height=500&seq=focus-4-51cg-2026&orientation=landscape',
    title: '综艺节目幕后：那些镜头之外的精彩故事',
    desc: '剪辑师不敢放的片段、导演不能说的话题，揭秘综艺节目真正的录制现场。',
    tag: '独家揭秘',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxury%20fashion%20brand%20endorsement%20concept%20with%20elegant%20products%20and%20spotlight%2C%20celebrity%20brand%20deal%20vibe%2C%20warm%20golden%20and%20dark%20elegant%20atmosphere%2C%20high%20fashion%20commercial%20photography%20style&width=800&height=500&seq=focus-5-51cg-2026&orientation=landscape',
    title: '明星代言背后的商业博弈与品牌选择',
    desc: '代言费动辄千万，品牌方和明星之间究竟如何博弈？深入剖析代言经济的台前幕后。',
    tag: '行业观察',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            焦点专题
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">深度报道与独家策划，带你了解事件全貌</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {focusItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors group flex flex-col"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs font-bold bg-primary-500 text-background-50 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}